import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { JwBreadcrumb } from "../components/JwBreadcrumb";
import { JwExplainer } from "../components/JwExplainer";
import { JwtTool } from "../components/JwtTool";

export function JwtDecoderPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <JwBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.jw_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.jw_intro()}
          </p>
        </header>

        <JwtTool />

        <JwExplainer
          howTo={m.jw_howto()}
          faqs={[
            { q: m.jw_faq1_q(), a: m.jw_faq1_a() },
            { q: m.jw_faq2_q(), a: m.jw_faq2_a() },
            { q: m.jw_faq3_q(), a: m.jw_faq3_a() },
            { q: m.jw_faq4_q(), a: m.jw_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
